import React from 'react';
import PropTypes from 'prop-types';
import { SM } from '@zendeskgarden/react-typography';
import Flex from 'styled-flex-component';
import { reduce, replace, includes, map, filter, size, noop } from 'lodash';

import { elementsToAbbrev, elementNumbers } from 'utility/staticMap.ts';
import ElementBlock from 'components/AlloyComposition/components/ElementBlock/ElementBlock';
import { metallurgyShape } from 'propTypesObjects';

function AlloyComposition({ data, legacy, renderTitle = noop }) {
  let currentData = data || {};
  currentData = reduce(
    currentData,
    (accum, value, key) => {
      const currentAccum = accum || {};
      const elementNames = replace(replace(key, '_max', ''), '_min', '');
      const minOrMax = includes(key, '_min') ? 'min' : 'max';
      const abbreviation = elementsToAbbrev[elementNames];
      const elementNumber = elementNumbers[elementNames];
      if (!abbreviation) {
        return currentAccum;
      }
      if (currentAccum[elementNames]) {
        currentAccum[elementNames] = {
          ...currentAccum[elementNames],
          [minOrMax]: value,
        };
      } else {
        currentAccum[elementNames] = {
          [minOrMax]: value,
          abbreviation,
          elementNumber,
          elementName: elementNames,
        };
      }
      return currentAccum;
    },
    {}
  );

  const columns = map(
    filter(currentData, ({ min, max }) => min || max),
    ({ min, max, abbreviation }, key, arr) => {
      const minWidth =
        String(min).length === 7 || String(max).length === 7 ? '55px' : '44px';
      return min || max ? (
        <div
          style={{
            minWidth,
            width: `${100 / arr.length - 1}%`,
            paddingRight: 0,
          }}
          key={key}
        >
          <SM paddingTopXs style={{ minWidth: '20px' }} bold>
            {abbreviation}
          </SM>
          <SM
            paddingTopXs
            style={{ fontSize: '12px', width: '100%', minWidth }}
            grey={!min}
          >
            {min ? `${Number(min).toString()}%` : '×'}
          </SM>
          <SM
            paddingTopXs
            style={{ fontSize: '12px', width: '100%', minWidth }}
            grey={!max}
          >
            {max ? `${Number(max).toString()}%` : '×'}
          </SM>
        </div>
      ) : null;
    }
  );

  const newColumns = map(
    filter(currentData, ({ min, max }) => min || max),
    ({ min, max, abbreviation, elementNumber, elementName }, key, arr) => {
      const minWidth =
        Number(min || 0).toString() === 7 || Number(max || 0).toString() === 7
          ? '55px'
          : '44px';
      return (
        (min || max) && (
          <ElementBlock
            className="element"
            abbreviation={abbreviation}
            elementName={elementName}
            elementNumber={elementNumber}
            elements={arr}
            minWidth={minWidth}
            min={min}
            max={max}
            key={key}
          />
        )
      );
    }
  );

  return columns.length && legacy ? (
    <Flex>
      <div style={{ paddingRight: 0 }}>
        <SM
          paddingTopXs
          style={{ fontSize: '12px', width: '100%', minWidth: '40px' }}
          bold
        >
          El.
        </SM>
        <SM
          paddingTopXs
          style={{ fontSize: '12px', width: '100%', minWidth: '40px' }}
          bold
        >
          Min:
        </SM>
        <SM
          paddingTopXs
          style={{ fontSize: '12px', width: '100%', minWidth: '40px' }}
          bold
        >
          Max:
        </SM>
      </div>
      {columns}
    </Flex>
  ) : (
    <div>
      {!!size(newColumns) && (
        <>
          {renderTitle()}
          <Flex
            style={{
              width: '100%',
              maxWidth: '100%',
              overflowX: 'auto',
            }}
          >
            {newColumns}
          </Flex>
        </>
      )}
    </div>
  );
}

AlloyComposition.propTypes = {
  data: metallurgyShape,
  legacy: PropTypes.bool,
  renderTitle: PropTypes.func,
};

export default AlloyComposition;
